import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Typography from "@material-ui/core/Typography";
import "react-responsive-modal/styles.css";
import { Button, TextField } from "@material-ui/core";

const VendorBootTable = ({
  data,
  vendorListSelectedEmails,
  vendorGstinMails,
  handleVendorListSubmit,
}) => {
  const [selected, setSelected] = useState(vendorListSelectedEmails);
  const [vendorGstinMailsState, setVendorGstinMailsState] =
    useState(vendorGstinMails);
  const [searchText, setSearchText] = useState("");

  const handleSubmit = () => {
    handleVendorListSubmit(selected, vendorGstinMailsState);
  };

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      const newVendorGstinEmail = [
        ...vendorGstinMailsState,
        { gstin: row.gstin, email: [row.email] },
      ];
      setVendorGstinMailsState(newVendorGstinEmail);

      setSelected((prevSelected) => [...prevSelected, row.listKey]);
    } else {
      const newVendorGstinEmail = vendorGstinMailsState.filter(
        (item) => !(item.gstin === row.gstin && item.email[0] === row.email)
      );
      setVendorGstinMailsState(newVendorGstinEmail);

      setSelected((prevSelected) =>
        prevSelected.filter((key) => key !== row.listKey)
      );
    }
  };

  const handleOnSelectAll = (isSelect, rows) => {
    if (isSelect) {
      const listKeys = rows.map((row) => row.listKey);
      const vendorGstinMails = rows.map((row) => ({
        gstin: row.gstin,
        email: [row.email],
      }));

      setVendorGstinMailsState(vendorGstinMails);
      setSelected(listKeys);
    } else {
      setVendorGstinMailsState([]);
      setSelected([]);
    }
  };

  const filteredData = (data) => {
    if (!searchText) return data;

    const regex = new RegExp(searchText, "i");
    return data.filter(
      (item) =>
        regex.test(item.email) ||
        regex.test(item.gstin) ||
        regex.test(item.name)
    );
  };

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    selected,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    headerColumnStyle: {
      width: "37px",
      verticalAlign: "text-top",
    },
    selectColumnStyle: {
      width: "37px",
    },
  };

  const rowStyle2 = (row, rowIndex) => ({
    backgroundColor: "white",
    textAlign: "center",
    cursor: "pointer",
  });

  const columns = [
    {
      dataField: "gstin",
      text: "Vendor GSTIN",
      style: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "11px",
        fontWeight: "bold",
        color: "#4f2d7f",
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "20%",
      },
    },
    {
      dataField: "name",
      text: "Vendor Name",
      style: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "11px",
        fontWeight: "bold",
        color: "#4f2d7f",
        textWrap: "wrap",
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "email",
      text: "Vendor Email",
      style: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "11px",
        fontWeight: "bold",
        color: "#4f2d7f",
        textWrap: "wrap",
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "20%",
      },
    },
  ];

  return (
    <div>
      {data && (
        <div>
          {data.length !== 0 ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "15px",
                }}
              >
                <TextField
                  id="outlined-basic"
                  label="Search"
                  variant="outlined"
                  type="search"
                  size="small"
                  onChange={(e) => setSearchText(e.target.value)}
                />
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    backgroundColor: "#6f42c1",
                    color: "white",
                    width: "22%",
                    height: "34px",
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </div>
              <div style={{ overflowX: "auto" }}>
                <BootstrapTable
                  keyField="listKey"
                  data={filteredData(data)}
                  columns={columns}
                  selectRow={selectRow}
                  rowStyle={rowStyle2}
                />
              </div>
            </>
          ) : (
            <Typography
              style={{
                fontFamily: "GT-Walsheim-medium",
                fontSize: "30px",
                whiteSpace: "nowrap",
                color: "darkslategray",
                display: "flex",
                justifyContent: "center",
              }}
            >
              No Vendors Data Found
            </Typography>
          )}
        </div>
      )}
    </div>
  );
};

export default VendorBootTable;
